export const gameLayers = {
  popup: 'popup',
  betBar: 'betBar',
  slotBar: 'slotBar',
  spinBar: 'spinBar',
  menuBar: 'menuBar',
  introBar: 'introBar',
  gambleBar: 'gambleBar',
  slotBoard: 'slotBoard',
  freeBetBar: 'freeBetBar',
  lineWinBar: 'lineWinBar',
  jackPotBar: 'jackPotBar',
  background: 'background',
  gameJackpot: 'gameJackpot',
  winPopupBar: 'winPopupBar',
  notification: 'notification',
  expandWildBar: 'expandWildBar',
  boostedJackpot: 'boostedJackpot',
  boostedWheel: 'boostedWheel',
  boostedInfo: 'boostedInfo',
};

export const autoBetCounts = [10, 20, 50, 100];
export const specificLocalStorageKeys = { isHideIntro: 'isHideIntro' };
export const WinningLinesCoordinate10 = [
  [
    { x: 1, y: 0 },
    { x: 1, y: 1 },
    { x: 1, y: 2 },
    { x: 1, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 0, y: 1 },
    { x: 0, y: 2 },
    { x: 0, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 2, y: 1 },
    { x: 2, y: 2 },
    { x: 2, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 1, y: 1 },
    { x: 2, y: 2 },
    { x: 1, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 1, y: 1 },
    { x: 0, y: 2 },
    { x: 1, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 0, y: 1 },
    { x: 1, y: 2 },
    { x: 2, y: 3 },
    { x: 2, y: 4 },
  ],
  [
    { x: 2, y: 0 },
    { x: 2, y: 1 },
    { x: 1, y: 2 },
    { x: 0, y: 3 },
    { x: 0, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 2, y: 1 },
    { x: 2, y: 2 },
    { x: 2, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 1, y: 0 },
    { x: 0, y: 1 },
    { x: 0, y: 2 },
    { x: 0, y: 3 },
    { x: 1, y: 4 },
  ],
  [
    { x: 0, y: 0 },
    { x: 1, y: 1 },
    { x: 1, y: 2 },
    { x: 1, y: 3 },
    { x: 0, y: 4 },
  ],
];

export const linesInfo = [
  [1, 1, 1, 1, 1],
  [0, 0, 0, 0, 0],
  [2, 2, 2, 2, 2],
  [0, 1, 2, 1, 0],
  [2, 1, 0, 1, 2],
  [0, 0, 1, 2, 2],
  [2, 2, 1, 0, 0],
  [1, 2, 2, 2, 1],
  [1, 0, 0, 0, 1],
  [0, 1, 1, 1, 0],
];

export const GAMBLE_MAX_COUNT = 8;
export const SPIN_BUTTON_SCALE_OUT_X_AND_Y = 1;
export const SPIN_BUTTON_SCALE_IN_X_AND_Y = 0.9;
export const SPIN_BUTTON_SCALE_REPEAT_COUNT = 1;
export const WEB_BET_CONTAINER_START_POSITION_X = 0;
export const MOBILE_BET_CONTAINER_START_POSITION_X = 87;
export const SPIN_BUTTON_ROTATION_IN_LOOP = Math.PI * 0.5;
export const SPIN_BUTTON_ARROWS_LOOP_ANIMATION_DURATION = 0.3;
export const SPIN_BUTTON_ARROWS_ROTATION_IN_CLICK = Math.PI * 2;
export const PG_COIN = 'PGCOIN';
